import debug from "src/modules/debug-logger";
import environment from "src/utils/environment";

const remote = window.require("@electron/remote");
const { globalShortcut, getCurrentWindow, getCurrentWebContents } = remote;

function registerShortcuts() {
  debug.general("Registering global shortcuts");

  const webContents = getCurrentWebContents();

  const didRegisterCopy = globalShortcut.register("CommandOrControl+C", () => {
    webContents.copy();
  });
  if (!didRegisterCopy) {
    debug.general("Failed to register CommandOrControl+C as Copy shortcut");
  }

  const didRegisterPaste = globalShortcut.register("CommandOrControl+V", () => {
    webContents.paste();
  });
  if (!didRegisterPaste) {
    debug.general("Failed to register CommandOrControl+V as Paste shortcut");
  }

  const didRegisterCut = globalShortcut.register("CommandOrControl+X", () => {
    webContents.cut();
  });
  if (!didRegisterCut) {
    debug.general("Failed to register CommandOrControl+X as Cut shortcut");
  }

  const didRegisterSelectAll = globalShortcut.register(
    "CommandOrControl+A",
    () => {
      webContents.selectAll();
    }
  );
  if (!didRegisterSelectAll) {
    debug.general(
      "Failed to register CommandOrControl+A as SelectAll shortcut"
    );
  }
}

function unregisterShortcuts() {
  debug.general("Unregistering all global shortcuts");
  globalShortcut.unregisterAll();
}

function setupGlobalShortcuts() {
  const browserWindow = getCurrentWindow();

  if (browserWindow.isFocused()) {
    registerShortcuts();
  }

  browserWindow.addListener("focus", registerShortcuts);
  browserWindow.addListener("blur", unregisterShortcuts);
  browserWindow.addListener("close", unregisterShortcuts);
}

// we set application menu in dev mode only for darwin
// it enables shortcuts in dev tools as well
if (!environment.isBrowser) {
  if (environment.isDev && environment.platform !== "darwin") {
    setupGlobalShortcuts();
  } else if (!environment.isDev) {
    setupGlobalShortcuts();
  }
}
